var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
   This files define interface specific to single-spa framework
   which make D2 a pluggable component of platform2-lib repository.

   This entry is meant to be compiled to AMD or Systemjs module
   with public interface containing:

   * bootstrap
   * mount
   * unmount
*/
import { ximport } from "@globalwebindex/platform2-lib";
import { monkeyPatchXtag } from "../../_helpers/webcomponents";
import { p2EnvPlatform } from "../../_helpers/platform";
import keysInit from "../../_initializer/keys";
import p2UrlInit from "../../_initializer/p2-url";
import analyticsInit from "../../_initializer/analytics";
import analyticsPorts from "../../_port/analytics";
import windowPorts from "../../_port/window";
import scrollPorts from "../../_port/scroll";
import intercomPorts from "../../_port/intercom";
import accessTokenHandler from "../../_port/accessToken";
import clipboardPorts from "../../_port/clipboard";
import "regenerator-runtime/runtime";
require("@webcomponents/webcomponentsjs/webcomponents-bundle.js");
require("@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js");
// styles
require("./main.scss");
// Webcomponents
window.xtag = require("x-tag");
monkeyPatchXtag();
require("../../_x-tag/x-dashboards-chart-2/component");
require("../../_x-tag/x-dashboards-chart-2/style.scss");
// New Web Components
require("../../webcomponents");
require("../../custom-elements/x-cooltip/component.ts");
require("../../custom-elements/x-cooltip/style.scss");
require("../../custom-elements/x-simplebar/component.ts");
require("../../custom-elements/x-simplebar/style.scss");
require("../../custom-elements/x-d3scription/component.ts");
require("../../custom-elements/x-resize-observer/component.ts");
// CONFIG DEFINITIONS
var styleHref = "/assets/dashboards.css";
var state = {
    dashboardEdited: false,
    ignoreNextRouteChangeCounter: 0,
    lastUrl: "",
    currentUrl: ""
};
function getDomElement(domId) {
    var htmlId = domId !== undefined ? domId : "container";
    var domElement = document.getElementById(htmlId);
    if (!domElement) {
        domElement = document.createElement("div");
        domElement.id = htmlId;
        document.body.appendChild(domElement);
    }
    return domElement;
}
function getSharedStateFromKernel(state) {
    // @ts-ignore
    if (state && (state.type === "AddingAttributesToDashboards" || state.type === "CreatingDashboard")) {
        return state.payload;
    }
    else {
        return null;
    }
}
function initENV(props) {
    var ENV = JSON.parse(JSON.stringify(props));
    ENV.platform = ENV.platform || p2EnvPlatform;
    keysInit(ENV);
    p2UrlInit(ENV);
    return ENV;
}
// SINGLE-SPA INTERFACE LOGIC
/** Bootstrap function needs to handle provision of all resources
as well as take core of main intialization of the app.
*/
export function bootstrap(props) {
    return ximport(styleHref)
        .then(function () {
        return import(
        /* webpackChunkName: "dashboards-elm" */
        /* webpackMode: "eager" */
        // @ts-ignore
        "./src/Dashboards2Main");
    })
        .then(function (_a) {
        var Elm = _a.Elm;
        // Container element
        // Elm is going to rewrite this node so it disappears
        var element = document.createElement("div");
        var domElement = getDomElement(props.domId);
        domElement.innerHTML = '';
        // wrapper is a dom node we use to control the lifecycle
        var wrapper = document.createElement("div");
        wrapper.className = "dashboards2-wrapper";
        wrapper.appendChild(element);
        domElement.appendChild(wrapper);
        var ENV = initENV(props);
        var app = Elm.Dashboards2Main.init({
            node: element,
            flags: ENV // Using global state again
        });
        // @ts-ignore
        state.domEl = wrapper;
        // @ts-ignore
        state.app = app;
    });
}
/** Mount application should handle render of the DOM of the application
and hook to events / subscriptions which are not necessary un unmounted state.
*/
export function mount(props) {
    var _this = this;
    // @ts-ignore
    var app = state.app, domEl = state.domEl;
    var ENV = initENV(props);
    analyticsInit(ENV);
    return new Promise(function (resolve) {
        var mountedHandler = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    app.ports.mountedD2.unsubscribe(mountedHandler);
                    // @ts-ignore
                    resolve();
                    return [2 /*return*/];
                });
            });
        };
        // @ts-ignore
        state.navigateTo = function (str) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // @ts-ignore
                    window.singleSpaNavigate(str);
                    return [2 /*return*/];
                });
            });
        };
        // @ts-ignore
        state.editedStateSubscription = function (edited) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    state.dashboardEdited = edited;
                    return [2 /*return*/];
                });
            });
        };
        // @ts-ignore
        state.routeChanged = function () {
            if (state.lastUrl !== window.location.href) {
                if (state.ignoreNextRouteChangeCounter <= 0) {
                    app.ports.routeChangedD2.send(window.location.href);
                }
                else {
                    state.ignoreNextRouteChangeCounter--;
                }
            }
            state.lastUrl = window.location.href;
        };
        // @ts-ignore
        state.beforeRouting = function (evt) {
            if (state.dashboardEdited &&
                evt.detail.newUrl.indexOf("/dashboards") === -1) {
                evt.detail.cancelNavigation();
                /**
                 * This whole SPA whatever kernel thing is wird as ***, you have `before-routing-event`
                 * but even if it's before route change is already done and if you cancel it, it just simply
                 * jump back to previous route so there are two route changes triggered even if nothing should happen.
                 * And yes, I tried preventDefault and stopPropagation usual JS magic, but no luck here.
                 * So here comes this hack. It's terribly stupid, but because SPA is 4rd party lib,
                 * I did not see other reasonable option.
                 * */
                state.ignoreNextRouteChangeCounter = 2;
                new Promise(function (resolve, _reject) {
                    // @ts-ignore
                    state.interruptRoutingStatusHandler = function (state) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            resolve(state);
                            return [2 /*return*/];
                        });
                    }); };
                    app.ports.interruptRoutingStatus.subscribe(
                    // @ts-ignore
                    state.interruptRoutingStatusHandler);
                    app.ports.checkRouteInterruption.send(evt.detail.newUrl);
                }).finally(function () {
                    app.ports.interruptRoutingStatus.unsubscribe(
                    // @ts-ignore
                    state.interruptRoutingStatusHandler);
                });
            }
            /** Another great behaviour of single-spa. If there is routing-event, but for different app
             *  (like going from Dashboards to reports/insights..) it will not fire `single-spa:routing-event`
             * for this APP. But `single-spa:before-routing-event` is still fired. What a intuitive behaviour.
             * So we need to set lastUrl here in case of different URL
             *
             * */
            if (evt.detail.newUrl.indexOf("/dashboards") === -1) {
                state.lastUrl = window.location.href;
            }
        };
        // hook routing
        // @ts-ignore
        window.addEventListener("single-spa:routing-event", state.routeChanged);
        window.addEventListener("single-spa:before-routing-event", 
        // @ts-ignore
        state.beforeRouting);
        // Ports communication
        accessTokenHandler(app).init();
        app.ports.mountedD2.subscribe(mountedHandler);
        // @ts-ignore
        app.ports.navigateToD2.subscribe(state.navigateTo);
        app.ports.mountD2.send(null);
        app.ports.setDashboardEditedState.subscribe(
        // @ts-ignore
        state.editedStateSubscription);
        // setTextareaCursorPosition
        app.ports.setTextareaCursorPosition.subscribe(function (_a) {
            var id = _a[0], value = _a[1];
            return __awaiter(_this, void 0, void 0, function () {
                var element;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            element = document.getElementById(id);
                            if (!element) return [3 /*break*/, 2];
                            // @ts-ignore
                            return [4 /*yield*/, element.setSelectionRange(value, value)];
                        case 1:
                            // @ts-ignore
                            _b.sent();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        });
        // @ts-ignore
        state.clarSharedStateSubscription = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                props.setSharedState({
                    type: "AddingAttributesToDashboards",
                    payload: null
                });
                props.setSharedState({
                    type: "CreatingDashboard",
                    payload: null
                });
                return [2 /*return*/];
            });
        }); };
        app.ports.clearSharedStateFromKernel.subscribe(
        // @ts-ignore
        state.clarSharedStateSubscription);
        var sendSharedStateToElm = function () {
            var sharedState = getSharedStateFromKernel(props.getSharedState());
            if (sharedState !== null) {
                app.ports.setSharedStateFromKernel.send(sharedState);
            }
        };
        // @ts-ignore
        state.popStateListener = function (evt) {
            // @ts-ignore
            if (evt.singleSpa && evt.singleSpaTrigger === 'pushState') {
                // This event was fired by single-spa to forcibly trigger a re-render
                sendSharedStateToElm();
            }
        };
        // @ts-ignore
        window.addEventListener('popstate', state.popStateListener);
        // @ts-ignore
        state.sharedStateSubscription = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                sendSharedStateToElm();
                return [2 /*return*/];
            });
        }); };
        app.ports.getSharedStateFromKernel.subscribe(
        // @ts-ignore
        state.sharedStateSubscription);
        // @ts-ignore
        state.setSharedStateForChartBuilderAndNavigateTo = function (_a) {
            var payload = _a[0], url = _a[1];
            return __awaiter(_this, void 0, void 0, function () {
                var type, currentState, sharedState, i;
                return __generator(this, function (_b) {
                    type = 'AddingFiltersToChartBuilder';
                    currentState = props.getSharedState();
                    sharedState = { type: type, payload: payload };
                    // @ts-ignore
                    if (currentState && currentState.type === type) {
                        for (i in payload) {
                            currentState.payload[i] = payload[i];
                        }
                        sharedState = currentState;
                    }
                    props.setSharedState(sharedState);
                    // @ts-ignore
                    state.navigateTo(url);
                    return [2 /*return*/];
                });
            });
        };
        app.ports.setSharedStateForChartBuilderAndNavigateTo.subscribe(
        // @ts-ignore
        state.setSharedStateForChartBuilderAndNavigateTo);
        // @ts-ignore
        windowPorts.subscribeOpenNewWindowD2(app);
        // @ts-ignore
        analyticsPorts.subscribeTrack(app);
        // @ts-ignore
        analyticsPorts.subscribeBatch(app);
        // @ts-ignore
        scrollPorts.subscribeDebouncedScrollEvent(app);
        // @ts-ignore
        intercomPorts.subscribeOpenChatWithErrorId(app);
        // @ts-ignore
        clipboardPorts.subscribeAddHostAndCopyToClipboard(app);
        // @ts-ignore
        clipboardPorts.subscribeCopyToClipboard(app);
        // DOM operation
        var domElement = getDomElement(props.domId);
        domElement.appendChild(domEl);
    });
}
/** Unmount should take care of destruction of DOM
including event handlers / subscriptions that are not needed in unmounted state.
*/
export function unmount(props) {
    // @ts-ignore
    var app = state.app;
    return new Promise(function (resolve) {
        var unmountedHandler = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // unsubscribe from ports
                    accessTokenHandler(app).clear();
                    app.ports.unmountedD2.unsubscribe(unmountedHandler);
                    // @ts-ignore
                    app.ports.navigateToD2.unsubscribe(state.navigateTo);
                    app.ports.setDashboardEditedState.unsubscribe(
                    // @ts-ignore
                    state.editedStateSubscription);
                    // @ts-ignore
                    analyticsPorts.unsubscribeTrack(app);
                    // @ts-ignore
                    analyticsPorts.unsubscribeBatch(app);
                    // @ts-ignore
                    scrollPorts.unsubscribeDebouncedScrollEvent(app);
                    // @ts-ignore
                    intercomPorts.unsubscribeOpenChatWithErrorId(app);
                    // @ts-ignore
                    clipboardPorts.unsubscribeAddHostAndCopyToClipboard(app);
                    // @ts-ignore
                    clipboardPorts.unsubscribeCopyToClipboard(app);
                    window.removeEventListener("single-spa:routing-event", 
                    // @ts-ignore
                    state.routeChanged);
                    window.removeEventListener("single-spa:before-routing-event", 
                    // @ts-ignore
                    state.beforeRouting);
                    // @ts-ignore
                    window.removeEventListener('popstate', state.popStateListener);
                    state.lastUrl = null;
                    state.ignoreNextRouteChangeCounter = 0;
                    // @ts-ignore
                    resolve();
                    return [2 /*return*/];
                });
            });
        };
        // Ports communication
        app.ports.unmountedD2.subscribe(unmountedHandler);
        app.ports.unmountD2.send(null);
        app.ports.getSharedStateFromKernel.unsubscribe(
        // @ts-ignore
        state.sharedStateSubscription);
        app.ports.clearSharedStateFromKernel.subscribe(
        // @ts-ignore
        state.clarSharedStateSubscription);
        app.ports.setSharedStateForChartBuilderAndNavigateTo.unsubscribe(
        // @ts-ignore
        state.setSharedStateForChartBuilderAndNavigateTo);
        // DOM operation
        var domElement = getDomElement(props.domId);
        domElement.innerHTML = "";
    });
}
